import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';

import { AbstractControl, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipDirective } from '../tooltip.directive';

import { faTimes, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import { InputComponent } from '../input/input.component';
import { TextareaComponent } from '../textarea/textarea.component';

@Component({
  selector: 'app-form-input',
  standalone: true,
  imports: [
    TranslateModule,
    FontAwesomeModule,
    TooltipDirective,
    InputComponent,
    TextareaComponent
],
  templateUrl: './form-input.component.html',
  styleUrls: ['./form-input.component.scss'],
})
export class FormInputComponent {
  @ViewChild('formInput')
  formInput!: ElementRef<HTMLInputElement>;

  @Input() id?: string;
  @Input() control: FormControl = new FormControl();
  @Input() focus: boolean = false;
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() showRemoveButton: boolean = true;
  @Input() toggleEnabled: boolean = false;
  @Input() expanded: boolean = false;
  @Input() mentionData: string[] = [];
  @Input() type: 'input' | 'textarea' = 'input';

  @Output() toggle = new EventEmitter<void>();
  @Output() remove = new EventEmitter<void>();

  icons = {
    cancel: faTimes,
    down: faChevronDown,
    up: faChevronUp,
  };

  fc(control: FormControl | AbstractControl): FormControl {
    return control as FormControl;
  }

  removeDescription(): void {
    this.remove.emit();
  }

  onToggle(): void {
    this.toggle.emit();
  }
}
